import { mutatorAction } from 'satcheljs';
import getStore from './store';
import TextMessagingAccount from 'owa-service/lib/contract/TextMessagingAccount';

export default mutatorAction('setTextMessagingAccountData', (data: TextMessagingAccount) => {
    getStore().textMessagingAccount = data;
});
